import React from 'react';
import PropTypes from 'prop-types';

export const Footer = function (props) {
  const { footerText = '' } = props;
  return (
    <footer>
      <p id="copy">&copy; CYBERLINKS CO.,LTD.</p>
    </footer>
  );
};

export default Footer;

Footer.propTypes = {
  footerText: PropTypes.string.isRequired,
};
